/* tslint:disable */
/* eslint-disable */
/* @relayHash 0818a7b6d3248b7325423ffe3fca7901 */

import { ConcreteRequest } from "relay-runtime";
export type AddUserToAutopilotContactsInput = {
    userId: string;
    sessionId: string;
    clientMutationId?: string | null;
};
export type addUserToAutopilotContactsMutationVariables = {
    input: AddUserToAutopilotContactsInput;
};
export type addUserToAutopilotContactsMutationResponse = {
    readonly addUserToAutopilotContacts: {
        readonly clientMutationId: string | null;
    } | null;
};
export type addUserToAutopilotContactsMutation = {
    readonly response: addUserToAutopilotContactsMutationResponse;
    readonly variables: addUserToAutopilotContactsMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddUserToAutopilotContactsInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addUserToAutopilotContacts",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddUserToAutopilotContactsPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "addUserToAutopilotContactsMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "addUserToAutopilotContactsMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "addUserToAutopilotContactsMutation",
    "id": "ferrum/257.0.0-2020-03-23T16:51:22.788Z/addUserToAutopilotContactsMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'f94c4bd4ad3841be78a022b6d736e5cd';
export default node;
